// Types
import { RootState } from 'types/RootState.types';

import {
  getAppSessionExpiredSelector,
  getAppSubmitOrderTimeoutSelector,
  getAppShowEmptyBasketNotificationSelector,
  getPageNotFoundSelector,
  getAppOrderCompleteSelector,
} from '../../redux/reducers/app/appSelector';
import { getErrorSelector } from '../../redux/reducers/error/errorSelector';
import { getRouterLocationPathname } from '../../redux/reducers/router/routerSelector';
//
import routeConstants from '../../constants/routeConstants';

export const shouldCenterVertical = (state: RootState) => {
  const pathname = getRouterLocationPathname(state);
  const isPathExcluded = ![
    routeConstants.ORDER_CONFIRMATION,
    routeConstants.CALLBACK_ORDER_CLAIM,
    routeConstants.CALLBACK_CREATE_ACCOUNT,
    routeConstants.JOIN_MY_JL,
  ].some((routeConstant) => pathname.includes(routeConstant));

  const orderComplete = getAppOrderCompleteSelector(state);
  const showOrderCompleteNotification = orderComplete && isPathExcluded;

  const sessionExpired = getAppSessionExpiredSelector(state);
  const globalError = getErrorSelector(state);
  const submitOrderTimeout = getAppSubmitOrderTimeoutSelector(state);
  const showEmptyBasketNotification = getAppShowEmptyBasketNotificationSelector(state);
  const pageNotFound = getPageNotFoundSelector(state);

  return (
    !!globalError ||
    showEmptyBasketNotification ||
    showOrderCompleteNotification ||
    submitOrderTimeout ||
    sessionExpired ||
    pageNotFound
  );
};
